import { Box, IconButton } from '@mui/material';

import UserAvatar from '@components/UserAvatar';
import { EditIcon } from '@icons';
import { IAvatarBox } from './interfaces';
import { useStyles } from './styles';

/**
 * Avatar and display name at the top of the profile drawer, with the pencil
 * that opens the profile editor when the drawer hands one over.
 *
 * @param props.avatar - URL of the profile picture.
 * @param props.avatarFallback - Name the initials placeholder is built from.
 * @param props.name - Display name, rendered as given.
 * @param props.onEdit - Opens the profile editor; the pencil is only rendered
 * when this is passed.
 * @param props.editLabel - Accessible label of the pencil button.
 */
const AvatarBox = ({
  avatar,
  name,
  avatarFallback = '',
  onEdit,
  editLabel,
}: IAvatarBox) => {
  const classes = useStyles();

  return (
    <Box sx={classes.root}>
      <Box sx={classes.avatar}>
        <UserAvatar src={avatar} name={avatarFallback} />
      </Box>

      <Box sx={classes.name}>{name}</Box>

      {onEdit && (
        <IconButton
          sx={classes.editButton}
          onClick={onEdit}
          aria-label={editLabel}
          data-testid="user-profile-edit-btn"
        >
          <EditIcon sx={classes.editIcon} />
        </IconButton>
      )}
    </Box>
  );
};

export default AvatarBox;
